import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { SISTEMA_NOME } from '../sistema.ts';
import { TRANSLATIONS } from './resources.ts';

export const LANGUAGES = [
  { code: 'pt-BR', label: 'Português' },
  { code: 'en', label: 'English' },
] as const;

const STORAGE_KEY = 'app.language';

function initialLanguage(): string {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved && LANGUAGES.some((l) => l.code === saved)) return saved;
  } catch {
    // navegador sem armazenamento: segue o idioma do navegador
  }
  return navigator.language.toLowerCase().startsWith('pt') ? 'pt-BR' : 'en';
}

void i18n.use(initReactI18next).init({
  resources: {
    'pt-BR': { translation: TRANSLATIONS['pt-BR'] },
    en: { translation: TRANSLATIONS.en },
  },
  lng: initialLanguage(),
  fallbackLng: 'pt-BR',
  // {{sistema}} nos textos vira o nome do sistema (sistema.json).
  interpolation: { escapeValue: false, defaultVariables: { sistema: SISTEMA_NOME } },
});

i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
  try {
    localStorage.setItem(STORAGE_KEY, lng);
  } catch {
    // ignora
  }
});
document.documentElement.lang = i18n.language;

/** Texto cadastrado em vários idiomas (ex.: nome de perfil), no idioma atual. */
export function localized(text: Partial<Record<string, string>> | null | undefined): string {
  if (!text) return '';
  return text[i18n.language] ?? text['pt-BR'] ?? text.en ?? '';
}

export default i18n;
